import { inject, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { BeforeUnloadService } from "src/app/services/before-unload.service";

const DEFAULT_ICON = "fa-light fa-browser";

@Injectable()
export class TitleService {
  private title: string = "";
  private icon: string = DEFAULT_ICON;

  private readonly titleService = inject(Title);

  private readonly beforeUnloadAcquired$ =
    inject(BeforeUnloadService).acquired$;

  constructor() {
    this.beforeUnloadAcquired$.subscribe((isAcquired: boolean) => {
      this.set(this.getTitle());
    });
  }

  set(title: string, icon?: string | undefined): void {
    this.title = title;
    this.icon = icon || DEFAULT_ICON;

    const newTitle = `${this.beforeUnloadAcquired$.getValue() ? "*" : ""}${
      this.title
    }`;
    this.titleService.setTitle(newTitle);
  }

  getTitle(): string {
    return this.title || this.titleService.getTitle();
  }

  getIcon(): string {
    return this.icon;
  }
}
